import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import ImagePlaceholder from "./ImagePlaceholder";

const ImageWithFallback = ({ src, fallback, ...otherProps }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setIsLoaded(true);
    };
    img.src = src;
  }, [src]);

  return isLoaded ? (
    <img data-testid="original-image" {...{ src, ...otherProps }} />
  ) : (
    <>{fallback || <ImagePlaceholder {...otherProps} />}</>
  );
};

ImageWithFallback.propTypes = {
  /**
   * The provide the source of the image.
   */
  src: PropTypes.string,
  /**
   * Displays a fallback component in case no image is available.
   */
  fallback: PropTypes.node,
};

export default ImageWithFallback;
